const loadItems = (button) => {
	const totalPages = parseInt($("[data-total-pages]").val());
	let currentPage = parseInt($("[data-current-page]").val());
	let currentPageScroll = currentPage + 1;

	currentPage = currentPage + 1;
	const nextUrl = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + currentPage);
	const nextUrlScroll = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + currentPageScroll);
	$("[data-current-page]").val(currentPage);

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	$.ajax({
		url: nextUrl,
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			$(".load-more-grid").append(
				$(responseHTML).find(".load-more-grid").html()
			);
		},
		complete: function () {
			if (currentPage <= totalPages) {
				const scollData = document.querySelector(".infinite-scroll__data");
				if (scollData && currentPage != totalPages) {
					scollData.querySelector("input[data-next-url]").dataset.nextUrl =
						nextUrlScroll;
					scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
					scollData.querySelector(
						"input[data-current-page]"
					).dataset.currentPage = currentPage;
					scollData.querySelector("input[data-current-page]").value =
						currentPage;
					checkVisibility();
				}
				button.removeAttribute("disabled");
				button.classList.remove("loading");
				if (currentPage == totalPages) {
					button.remove();
				}
				const items = document.querySelectorAll("product-item");

				[...items].map(item => {
					if(+item.style.opacity === 0) {
						item.style.opacity = 1
					}
				})
			}
		},
	});
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");

	spinnerList.forEach((spinner) => {
		let hasTriggered = false;

		window.addEventListener("scroll", () => {
			if (!hasTriggered) {
				const rect = spinner.getBoundingClientRect();

				if (rect.top < window.innerHeight && rect.bottom >= 0) {
					loadItems(spinner);
					hasTriggered = true;
				}
			}
		});
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
}

(function () {
	loadMore();
})();
